module.exports = __webpack_public_path__ + "media/images/public_discussion-10ec18ba1c36cc5603130003f4a64b5e.svg";